
import { TranslationHandler } from '@/mixins/translation-handler'
import { PageModulesState } from '@/store/modules/page-modules'
import { ThemeState } from '@/store/modules/theme'
import { IIntro, IIntroWithoutThemeAndForms, ISection, ISectionFormWithoutThemeAndSectionData, ISectionWithoutThemeAndForms } from '@/types'
import { Component, Mixins } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import {
  injectFormInIntro,
  injectFormInSection,
  injectThemeInIntro,
  injectThemeInSection,
} from '@/utils/injectors'

@Component
export default class SpotifyConnect extends Mixins(TranslationHandler) {
  @Getter themeIsDark!: ThemeState['isDark']
  @Getter themeFont!: ThemeState['font']
  @Getter themePrimaryColor!: ThemeState['primaryColor']
  @Getter themeSecondaryColor!: ThemeState['secondaryColor']
  @Getter themeBackgroundColor!: ThemeState['backgroundColor']
  @Getter themeInputColor!: ThemeState['inputColor']
  @Getter themeFooterIconColor!: ThemeState['footerIconColor']
  @Getter themeText!: ThemeState['text']
  @Getter themeTextInput!: ThemeState['textInput']
  @Getter themeRounded!: ThemeState['rounded']
  @Getter themeLetterSpacing!: ThemeState['letterSpacing']
  @Getter themeButtonText!: ThemeState['buttonText']
  @Getter pageModulesHomeIntros!: PageModulesState['homeIntros']
  @Getter pageModulesHome!: PageModulesState['homePage']
  @Getter pageModulesSpotifyConnect!: PageModulesState['spotifyConnectPage']

  get theme (): IThemeValues {
    return {
      isDark: this.themeIsDark,
      text: this.themeText,
      font: this.themeFont,
      primaryColor: this.themePrimaryColor,
      secondaryColor: this.themeSecondaryColor,
      backgroundColor: this.themeBackgroundColor,
      inputColor: this.themeInputColor,
      textInput: this.themeTextInput,
      rounded: this.themeRounded,
      footerIconColor: this.themeFooterIconColor,
      buttonText: this.themeButtonText,
      letterSpacing: this.themeLetterSpacing,
    }
  }

  get gateForm (): ISectionFormWithoutThemeAndSectionData {
    return {
      type: 'form',
      data: {
        formType: 'newsletter',
        messages: {},
        background: '',
        inputs: [],
        isRequired: true,
      },
    }
  }

  get layout (): { intros: IIntro[]; sections: ISection[]; hasGatePlacement: boolean } {
    const sectionsSource = this.pageModulesSpotifyConnect.length > 0
      ? this.pageModulesSpotifyConnect
      : this.pageModulesHome
    const hasCustomPagePlacement = this.pageModulesSpotifyConnect.some((section) =>
      section.items.some((item) => item.type === 'form')
    )
    let hasGatePlacement = false
    const keepFirstForm = <T extends { items: any[] }>(container: T, allowForm = true): T => ({
      ...container,
      items: container.items.filter((item) => {
        if (item.type !== 'form') return true
        if (!allowForm) return false
        if (hasGatePlacement) return false
        hasGatePlacement = true
        return true
      }),
    })

    const intros = this.pageModulesHomeIntros
      .map((intro: IIntroWithoutThemeAndForms) => keepFirstForm(intro, !hasCustomPagePlacement))
      .map((intro) => injectThemeInIntro(injectFormInIntro(intro, this.gateForm), this.theme))

    const sections = sectionsSource
      .map((section: ISectionWithoutThemeAndForms) => keepFirstForm(section))
      .map((section) => injectThemeInSection(injectFormInSection(section, this.gateForm), this.theme))

    return { intros, sections, hasGatePlacement }
  }
}

type IThemeValues = Parameters<typeof injectThemeInIntro>[1]
